import {User, TeamAssignment, Team} from "@irati/types"
import { isManagerOfTeam } from "./role"

type TeamType = Pick<Team, "teamName" | "uuid">
type UserType = Pick<User, "teamAssignments">

export default (team: TeamType, user: UserType) => {
  return isManagerOfTeam(team, user) ? `${team.teamName} (${TeamAssignment.Manager})` : team.teamName
}
